import {LocationPoint} from '@/common/interfaces/location';
import {createAsyncThunk} from '@/app/store/createAsyncThunk';
import {selectDeviceCoordinates} from '../selectors';

/**
 * Determines exact user's device settlement using its coordinates.
 */
export const determinateExactSettlement = createAsyncThunk<
	{
		language: string;
	},
	{location: LocationPoint},
	void
>('geolocation/determinateExactSettlement', async ({language}, {context, getState, success}) => {
	const state = getState();
	const coordinates = selectDeviceCoordinates(state)!;

	const result = await context.backendAPI.location.determine(coordinates, language);
	return success(result);
});
